import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
//import { useParams } from 'react-router-dom'

import { IconButton, Icon, Panel } from 'rsuite'
import TagetDep6Form from './TagetDep6Form'
import TagetDep6Table from './TagetDep6Table'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import {
  getTargetDep6,
  saveTargetDep6,
  updateTargetDep6,
  deleteTargetDep6,
} from '../../../redux/actions/tagetDep6'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getSchemaSidebar } from '../../../redux/actions/sidebar'
import WarningMessage from '../../../components/message/WarningMessage/WarningMessage'
import TagetDep6CriterionWidget from './TagetDep6CriterionWidget'

export default function TagetDep6Widget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit, handleGetIndicator, type } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(props.schema)

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const handleUpdateSave = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response
      if (request.id) {
        console.log('call update.')
        response = await updateTargetDep6(projectId, type, request)
      } else {
        console.log('call save.')
        response = await saveTargetDep6(projectId, type, request)
      }
      // console.log('response', JSON.stringify(response))

      if (response) {
        setFormSchema(response)
        try {
          handleGetIndicator()
          await dispatch(getSchemaSidebar(projectId))
        } catch (e) {}
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDelete = async (id) => {
    startLoading()
    setIsLoading(true)
    setIsDeleteError(false)
    try {
      console.log('handleDelete id', id)
      console.log('call delete.')
      const status = await deleteTargetDep6(projectId, id)
      if (status === 200) {
        console.log('call get.')
        const _schema = await getTargetDep6(projectId, type)
        console.log(('result', _schema))
        setFormSchema(_schema)
        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsDeleteError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsDeleteError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)

    const request = {
      id: data.selectedId,
      projectVersionId: projectId,
      targetName: data.targetValue,
      targetTotal: data.targetTotal,
      targetUnit: data.targetUnit,
      targetDetail: data.targetDetail,
    }
    // console.log('request', JSON.stringify(request))
    handleUpdateSave(request)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      <WarningMessage style={{ marginTop: -10 }} message={formSchema?.feedbackBySubject} />

      {formSchema?.targetCriteria && (
        <TagetDep6CriterionWidget
          schema={formSchema.targetCriteria}
          showCommandButton={isEdit && showCommandButton}
          type={type}
        />
      )}

      {isEdit && showCommandButton ? (
        <TagetDep6Form
          key="key-tagetDep6"
          schema={formSchema}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
          onSubmit={handleSubmit(onSubmit)}
          onDelete={handleDelete}
          scrollToComponent={() => {
            scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
          }}
          isError={isError}
          isDeleteError={isDeleteError}
          loading={isLoading}
        />
      ) : (
        <TagetDep6Table isEdit={isEdit} schema={formSchema} />
      )}

      {showCommandButton && (
        <>
          <hr />
          {!isEdit ? (
            <IconButton
              appearance="ghost"
              className="rs-btn-ghost-edit"
              onClick={() => {
                onChangeIsEdit(!isEdit)
                setIsError(false)
                setIsDeleteError(false)
                scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
              }}
              icon={<Icon className="bt-gost-icon-radius-edit" icon="edit" />}
              disabled={isLoading}
            >
              {'เพิ่ม/แก้ไข' + (formSchema.buttonText ? formSchema.buttonText : '')}
            </IconButton>
          ) : (
            <div>
              <IconButton
                appearance="ghost"
                className="rs-btn-ghost-info"
                icon={<Icon className="bt-gost-icon-radius-info" icon="backward" />}
                onClick={(e) => {
                  onChangeIsEdit(!isEdit)
                  setIsError(false)
                  setIsDeleteError(false)
                  scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
                }}
                disabled={isLoading}
              >
                {'ดูรายการ' + (formSchema.buttonText ? formSchema.buttonText : '')}
              </IconButton>
            </div>
          )}
        </>
      )}
    </Panel>
  )
}
